import { ArtifactGenerator, Idea } from './ArtifactGenerator';

export class PresentationGenerator extends ArtifactGenerator {
  generatePrompt(): string {
    return `You are an expert presentation writer who specializes in creating compelling slide decks.
I will provide a set of ideas below, and I'd like you to create a comprehensive presentation outline.

Context and Ideas:

${this.getIdeaHierarchy()}

Please create a detailed presentation outline following this structure:

# [Title Slide]
- Compelling title that captures the essence of the presentation
- Subtitle that clarifies the main benefit or outcome
- Presenter information

# Executive Summary
- Key message
- Problem statement
- Solution overview
- Expected outcomes

# Agenda
- Clear outline of presentation sections
- Time allocations for each section
- Key topics to be covered

# Problem/Opportunity
- Current situation analysis
- Pain points and challenges
- Market opportunity
- Why now?

# Solution Overview
- Core value proposition
- Key features and benefits
- Competitive advantages
- Technical architecture overview

# Product Demo/Walkthrough
- Key features demonstration
- User journey
- Technical implementation
- Integration points

# Market Analysis
- Target market size
- Customer segments
- Competitive landscape
- Market trends

# Implementation Strategy
- Development roadmap
- Resource requirements
- Timeline
- Key milestones

# Success Metrics
- KPIs and metrics
- Expected outcomes
- Measurement methodology
- Success criteria

# Risk Analysis
- Potential challenges
- Mitigation strategies
- Dependencies
- Contingency plans

# Next Steps
- Immediate actions
- Resource allocation
- Timeline
- Decision points

# Q&A Preparation
- Anticipated questions
- Detailed answers
- Supporting data
- Follow-up items

For each slide:
- Include main talking points
- Add relevant statistics or data
- Include visual suggestions
- Note any demos or interactive elements
- Provide speaker notes

Formatting Guidelines:
- Use markdown for clear structure
- Keep points concise and impactful
- Use consistent formatting
- Include placeholders for visuals
- Note timing for each section

The presentation should be:
- Professional yet engaging
- Data-driven where possible
- Visually oriented
- Story-driven
- Action-focused

Generate the complete presentation outline now, using proper markdown formatting and maintaining a professional, engaging tone.`;
  }

  protected getIdeaHierarchy(): string {
    return this.ideas.map(idea => {
      let hierarchy = `- ${idea.content}`;
      if (idea.children.length > 0) {
        hierarchy += '\n' + this.getIdeaHierarchyRecursive(idea.children, 1);
      }
      return hierarchy;
    }).join('\n');
  }

  private getIdeaHierarchyRecursive(ideas: Idea[], level: number): string {
    return ideas.map(idea => {
      let hierarchy = `${'  '.repeat(level)}- ${idea.content}`;
      if (idea.children.length > 0) {
        hierarchy += '\n' + this.getIdeaHierarchyRecursive(idea.children, level + 1);
      }
      return hierarchy;
    }).join('\n');
  }
}
